// import echarts from "echarts";
import * as echarts from "echarts";
export function loadChart(myChart, data, times, name) {
  // 颜色设置
  let mz;
  if (name == "万吨") {
    mz = "产量";
  } else if (name == "万元") {
    mz = "产值";
  } else if (name == "万亩") {
    mz = "面积";
  }
  myChart.setOption({
    tooltip: {
      show: true,
      trigger: "item",
      backgroundColor: "rgba(11,36,74,.6)"
    },
    grid: {
      left: "2%",
      top: 30,
      right: "6%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        data: times,
        axisLabel: {
          show: true,
          textStyle: {
            color: "#ffffff",
            fontSize: "0.08rem"
          }
        },
        axisTick: {
          show: false //不显示刻度
        },
        axisLine: {
          lineStyle: {
            color: "#B2B7BF",
            width: 0.5 //这里是为了突出显示加上的
          }
        }
      }
    ],
    yAxis: [
      {
        type: "value",
        name: "年产值(" + name + ")",
        axisLine: {
          onZero: false,
          show: false,
          lineStyle: {
            color: "#B2B7BF",
            width: 1 //这里是为了突出显示加上的
          }
        },
        axisTick: {
          show: false //不显示刻度
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: "#ffffff" //字体颜色
          }
        },
        splitLine: {
          //保留网格线
          show: true,
          lineStyle: {
            //y轴网格线设置
            color: "#31446A",
            width: 1,
            type: "dashed"
          }
        }
      }
    ],
    series: [
      {
        name: mz,
        type: "line",
        smooth: true,
        symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 6,
        stack: 100,
        itemStyle: {
          color: "#0C85DD",
          emphasis: {
            color: "#0C85DD"
          }
        },
        markLine: {
          silent: true,
          symbol: ["none", "triangle"],
          symbolSize: 5,
          lineStyle: {
            color: "#0C85DD"
          },
          label: {
            show: false
          },
          data: [
            {
              yAxis: 10000
            },
            {
              yAxis: 20000
            },
            {
              yAxis: 30000
            },
            {
              yAxis: 40000
            }
          ]
        },
        lineStyle: {
          // 系列级个性化折线样式
          width: 3,
          type: "solid",
          color: "#00A7FD"
        },
        areaStyle: {
          normal: {
            //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(0,167,253,0.5)" // 0% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(8,54,104,0.3)" // 100% 处的颜色
              }
            ]) //背景渐变色
          }
        },
        data: data
      }
    ]
  });
}
